import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import { createOrUpdateUserIntermediateDetailsGraphQlMutation } from '../../../graphQL/NiatApplicationPortal/mutations/createOrUpdateUserIntermediateDetails';
import {
  MutationGraphQlResponseType,
  UpdateUserIntermediateDetailRequestObjectType
} from '../../../services/IbUserAccountsServices/GraphQlService/types';

import { useIbUserAccountsGraphQLService } from '../useIbUserAccountsGraphQLService';

interface UseUpdateUserIntermediateDetailGraphQlInterface {
  updateUserIntermediateDetailGraphQLApi: UseMutateAsyncFunction<
    MutationGraphQlResponseType,
    Error,
    UpdateUserIntermediateDetailRequestObjectType
  >;
  error: string | null;
  status: MutationStatus;
}

const useUpdateUserIntermediateDetailGraphQl =
  (): UseUpdateUserIntermediateDetailGraphQlInterface => {
    const { ibUserAccountsGraphQLService } = useIbUserAccountsGraphQLService();

    const updateUserIntermediateDetail = (
      data: UpdateUserIntermediateDetailRequestObjectType
    ) => {
      const mutationDetail =
        createOrUpdateUserIntermediateDetailsGraphQlMutation();

      return ibUserAccountsGraphQLService.ibUserAccountsGraphQlMutation(
        mutationDetail.mutation,
        {
          user_intermediate_details_input: data
        }
      );
    };

    const { mutateAsync, error, status } = useMutation(
      updateUserIntermediateDetail,
      {
        mutationKey: ['updateUserIntermediateDetailGraphQLApi']
      }
    );

    return {
      updateUserIntermediateDetailGraphQLApi: mutateAsync,
      error: error ? getAPIErrorMessage(error) : null,
      status
    };
  };

export { useUpdateUserIntermediateDetailGraphQl };
